'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCustomerPrefs = exports.updateUser = exports.assignEmail = exports.resetPasswordReset = exports.checkResetHash = exports.setNewPassword = exports.resetPassword = exports.updatePassword = exports.logout = exports.loginThirdparty = exports.setLoadError = exports.verifyThirdparty = exports.loginWithRefreshToken = exports.login = undefined;
var _constants = require('@marmalade/constants');
var _constants2 = _interopRequireDefault(_constants);
var _updateFields = require('@marmalade/form/lib/actions/update-fields');
var _fieldInfo = require('@marmalade/form/lib/selectors/field-info');
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _isEqual = require('lodash/isEqual');
var _isEqual2 = _interopRequireDefault(_isEqual);
var _constants3 = require('./constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
var login = exports.login = function login(product, username, password, emailHash) {
  return {
    type: _constants3.actionTypes.LOGIN,
    payload: _axios2.default.post(_constants3.endpoints.auth(product), {
      username: username,
      password: password,
      client_id: _constants2.default.clientId[product],
      grant_type: 'password'
    }),
    meta: {
      clientId: _constants2.default.clientId[product],
      emailHash: emailHash
    }
  };
};
var loginWithRefreshToken = exports.loginWithRefreshToken = function loginWithRefreshToken(product, refresh_token, staffId) {
  return {
    type: _constants3.actionTypes.REFRESH_TOKEN,
    payload: _axios2.default.post(_constants3.endpoints.auth(product), {
      refresh_token: refresh_token,
      client_id: _constants2.default.clientId[product],
      grant_type: 'refresh_token'
    }),
    meta: {
      staffId: staffId,
      clientId: _constants2.default.clientId[product]
    }
  };
};
var verifyThirdparty = exports.verifyThirdparty = function verifyThirdparty(product, hash, policyId) {
  return {
    type: _constants3.actionTypes.THIRDPARTY_VERIFY,
    payload: _axios2.default.post(_constants3.endpoints.thirdpartyVerify(product), {
      hash: hash,
      policyId: policyId
    })
  };
};
var setLoadError = exports.setLoadError = function setLoadError(errorMessage) {
  return {
    type: _constants3.actionTypes.SET_LOAD_ERROR,
    payload: errorMessage
  };
};
var loginThirdparty = exports.loginThirdparty = function loginThirdparty(product, hash, policyId, firstName, lastName, dateOfBirth, addressPostcode) {
  return {
    type: _constants3.actionTypes.THIRDPARTY_LOGIN,
    payload: _axios2.default.post(_constants3.endpoints.thirdpartyLogin(product), {
      hash: hash,
      policyId: policyId,
      firstName: firstName,
      lastName: lastName,
      dateOfBirth: dateOfBirth,
      addressPostcode: addressPostcode
    }),
    meta: {
      clientId: _constants2.default.clientId[product]
    }
  };
};
var logout = exports.logout = function logout() {
  return {
    type: _constants3.actionTypes.LOGOUT
  };
};
var updatePassword = exports.updatePassword = function updatePassword(product, oldPassword, newPassword, history) {
  return {
    type: _constants3.actionTypes.UPDATE_PASSWORD,
    auth: true,
    product: product,
    request: {
      method: 'post',
      baseUrl: _constants3.endpoints.password(product),
      params: {
        old_password: oldPassword,
        new_password: newPassword
      },
      then: function then() {
        history.push('/change-password-complete');
      }
    }
  };
};
var resetPassword = exports.resetPassword = function resetPassword(product, email) {
  var auth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (auth) {
    return {
      type: _constants3.actionTypes.RESET_PASSWORD,
      auth: true,
      product: product,
      request: {
        method: 'post',
        baseUrl: _constants3.endpoints.password(product),
        params: {
          username: email
        }
      }
    };
  }
  return {
    type: _constants3.actionTypes.RESET_PASSWORD,
    payload: _axios2.default.post(_constants3.endpoints.password(product), {
      username: email
    })
  };
};
var setNewPassword = exports.setNewPassword = function setNewPassword(product, loginId, hash, newPassword) {
  return {
    type: _constants3.actionTypes.NEW_PASSWORD,
    payload: _axios2.default.post(_constants3.endpoints.passwordReset(product), {
      loginId: loginId,
      newPassword: newPassword,
      hash: hash
    })
  };
};
var checkResetHash = exports.checkResetHash = function checkResetHash(product, loginId, hash) {
  return {
    type: _constants3.actionTypes.CHECK_PASSWORD_RESET_HASH,
    payload: _axios2.default.post(_constants3.endpoints.resetHashCheck(product), {
      loginId: loginId,
      hash: hash
    })
  };
};
var resetPasswordReset = exports.resetPasswordReset = function resetPasswordReset() {
  return {
    type: _constants3.actionTypes.RESET_PASSWORD_RESET
  };
};
var assignEmail = exports.assignEmail = function assignEmail() {
  return {
    type: _constants3.actionTypes.ASSIGN_EMAIL
  };
};
var updateUser = exports.updateUser = function updateUser(newProps) {
  return {
    type: _constants3.actionTypes.UPDATE_USER,
    newProps: newProps
  };
};
var fetchCustomerPrefs = exports.fetchCustomerPrefs = function fetchCustomerPrefs(formId, values) {
  return function (dispatch, getState) {
    return dispatch({
      type: _constants3.actionTypes.FETCH_CUSTOMER_PREFS,
      auth: true,
      product: 'ldi',
      meta: {
        formId: formId
      },
      request: {
        baseUrl: (0, _constants3.marketingPrefs)(formId),
        method: typeof values !== 'undefined' ? 'post' : 'get',
        params: values,
        then: function then(response) {
          var selected = [];
          Object.keys(response.data.data).forEach(function (key) {
            if (~[].concat(_toConsumableArray(_constants3.marketingOptions.contact.map(function (obj) {
              return obj.value;
            })), _toConsumableArray(_constants3.marketingOptions.interests.map(function (obj) {
              return obj.value;
            }))).indexOf(key) && response.data.data[key]) {
              selected.push(key);
            }
          });
          var vals = (0, _fieldInfo.getValue)(getState(), formId, _constants3.contactPrefsFieldName);
          if (!(0, _isEqual2.default)((typeof vals !== 'undefined' ? [].concat(_toConsumableArray(vals)) : []).sort(), selected.sort())) {
            dispatch((0, _updateFields.setValue)(formId, _constants3.contactPrefsFieldName, selected));
          }
        }
      }
    });
  };
};